(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function initHeroes() {
    document.querySelectorAll('[data-ns-hero]').forEach(function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-ns-hero-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-ns-hero-dot]'));
      var previous = hero.querySelector('[data-ns-hero-prev]');
      var next = hero.querySelector('[data-ns-hero-next]');
      var delay = parseInt(hero.getAttribute('data-autoplay-seconds'), 10) || 6;
      var autoplay = hero.getAttribute('data-autoplay') === 'true' && slides.length > 1;
      var current = 0;
      var timer = null;

      if (!slides.length) return;

      function show(index, restart) {
        current = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (restart) start();
      }

      function start() {
        window.clearInterval(timer);
        if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(function () { show(current + 1, false); }, delay * 1000);
      }

      if (previous) previous.addEventListener('click', function () { show(current - 1, true); });
      if (next) next.addEventListener('click', function () { show(current + 1, true); });

      dots.forEach(function (dot, dotIndex) {
        dot.addEventListener('click', function () { show(dotIndex, true); });
      });

      hero.addEventListener('mouseenter', function () { window.clearInterval(timer); });
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', function () { window.clearInterval(timer); });
      hero.addEventListener('focusout', start);

      show(0, false);
      start();
    });
  }

  function initRails() {
    document.querySelectorAll('[data-ns-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-ns-rail-track]');
      var previous = rail.querySelector('[data-ns-rail-prev]');
      var next = rail.querySelector('[data-ns-rail-next]');

      if (!track) return;

      function distance() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function update() {
        if (previous) previous.disabled = track.scrollLeft <= 3;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      }

      if (previous) {
        previous.addEventListener('click', function () {
          track.scrollBy({ left: -distance(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: distance(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initCollectionViews() {
    document.querySelectorAll('[data-ns-collection-view]').forEach(function (group) {
      var targetSelector = group.getAttribute('data-target');
      var target = targetSelector ? document.querySelector(targetSelector) : null;
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-view]'));
      if (!target || !buttons.length) return;

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var list = button.getAttribute('data-view') === 'list';
          target.classList.toggle('ns-collection-list', list);
          buttons.forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });
    });
  }

  function initFaqs() {
    document.querySelectorAll('[data-ns-faq-group]').forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('details'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    });
  }

  function initHeaderState() {
    var header = document.querySelector('.ns-header-container');
    if (!header) return;

    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initStickyAddToCart() {
    document.querySelectorAll('[data-ns-sticky-atc]').forEach(function (bar) {
      var targetSelector = bar.getAttribute('data-target');
      var original = targetSelector ? document.querySelector(targetSelector) : null;
      var button = bar.querySelector('[data-ns-sticky-button]');
      var stickyPrice = bar.querySelector('[data-ns-sticky-price]');
      var originalPrice = document.querySelector('#ProductPrice');
      if (!original || !button) return;

      function sync() {
        button.disabled = original.disabled;
        button.textContent = original.disabled ? 'Sold out' : 'Add to cart';
        if (stickyPrice && originalPrice) stickyPrice.textContent = originalPrice.textContent.trim();
      }

      button.addEventListener('click', function () {
        if (!original.disabled) original.click();
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          bar.hidden = entries[0].isIntersecting;
        }, { threshold: 0.1 });
        observer.observe(original);
      }

      var stateObserver = new MutationObserver(sync);
      stateObserver.observe(original, { attributes: true, childList: true, subtree: true });
      if (originalPrice) stateObserver.observe(originalPrice, { childList: true, characterData: true, subtree: true });
      sync();
    });
  }

  ready(function () {
    initHeroes();
    initRails();
    initCollectionViews();
    initFaqs();
    initHeaderState();
    initStickyAddToCart();
  });
})();
